module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "controls j_controls",
    on: {
      "click": _vm.controlAction
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.played),
      expression: "played"
    }],
    staticClass: "play-icon j_play",
    class: {
      'disnone': !_vm.controlsFlag
    },
    staticStyle: {
      "display": "none"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.play($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/play-icon.png")
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.played),
      expression: "!played"
    }],
    staticClass: "pause-icon j_pause",
    class: {
      'disnone': !_vm.controlsFlag
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.pause($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/pause-icon.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mask1 j_mask1"
  }), _vm._v(" "), _c('div', {
    staticClass: "mask2 j_mask2"
  }), _vm._v(" "), _c('div', {
    staticClass: "mask3 j_mask3"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "left",
    class: {
      'opa0': !_vm.controlsFlag
    }
  }, [_c('div', {
    staticClass: "time j_start_time"
  }, [_vm._v("00:00")]), _vm._v(" "), _c('div', {
    staticClass: "bar-wrap j_bar"
  }, [_c('div', {
    staticClass: "bar",
    on: {
      "click": _vm.jumpTime
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "time j_end_time"
  }, [_vm._v("00:00")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mutedData),
      expression: "!mutedData"
    }],
    staticClass: "voice j_voice",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.muted($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/voice.png")
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mutedData),
      expression: "mutedData"
    }],
    staticClass: "exit voice j_muted",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.voice($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/muted.png")
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar j_progress_bar"
  }, [_c('div', {
    staticClass: "bar-circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44cf01bf"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/video/components/controller.vue
// module id = 161
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 13 14 16 17 18 19 20 21 23 25 26 28 29 30 31 32 36 37 40 42 70 74 75